import { CLUSTER_API } from '../API/BASE_URL';

export const getDocs = async () => {
  const response = await fetch(CLUSTER_API + 'residents/documentations/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
